import Tabs from 'components/Globals/Tabs';
import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getBodyStyle, getColor, Theme } from 'styles/theme';

export const RankingListsTabs = styled(Tabs)<{ theme: Theme }>`
  + .panel {
    [role="tabpanel"] {
      display: flex;
      flex-direction: column;
      gap: 24px;

      @media (${breakpoint.mdMin}) {
        & > a {
          align-self: end;
        }
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 16px;
      border-bottom: 1px solid ${getColor('borderPrimary')};
      padding-bottom: 24px;
      margin-bottom: -8px;
    }  
  }
`;

export const RankingItem = styled.li<{ theme: Theme; $rank: number }>`
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 9px 16px 8px 84px; 
    background: ${getColor('shadeBrandPrimary100')};
    ${getBodyStyle('graphikCond', { default: 'default' }, 'semiBold')};
    min-height: 62px;

    &.is-anchor {
      text-decoration: none;
      &:hover, &:focus {
        background: ${getColor('shadeBrandPrimary200')};
        text-decoration: none;
      }
    }
    
    &::before {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 0;
        top: 0;
        bottom: 0;
        width: 68px;
        padding: 8px;
        content: "${({ $rank }) => $rank}";
        background-color: ${getColor('surfaceBrand')};
        ${getBodyStyle('graphikCond', { default: 'xlarge' }, 'semiBold')};
        color: ${getColor('textWhite')};

    }

    address {
        ${getBodyStyle('graphikCond', { default: 'small' })};
        font-style: normal;
    }
`;
